import React from 'react'
import axios from 'axios'
import { connect } from 'react-redux'

import { getNotifications } from './routes/notifications/reducers/manageNotifications'
import getServerURL from './functions/getServerURL'
import { checkSSOToken } from "./routes/login/reducers/manageLogin"

class AuthenticationComponent extends React.Component {

  componentDidMount(){
    // this.checkToken()
    this.props.checkSSOToken()
  }

  checkToken = () => {
    axios({
      url: `${getServerURL()}token-check/`,
      method: "GET",
      headers:{
        "Authorization": "Bearer " + localStorage.getItem("token")
      }
    })
    .then(response => {
      if (this.props.userId) {
        this.props.getNotifications(this.props.userId)
      }
      return null
    })
    .catch(error => {
      if (window.localStorage.getItem('token')) {
        let rememberMe = ""
        if(localStorage.getItem("rememberMe")) rememberMe = localStorage.getItem("rememberMe")
        localStorage.clear()
        if(rememberMe){
          localStorage.setItem("rememberMe", rememberMe)
        }
        window.location = '/'
      }
    })
  }

  render () {
    return null
  }
}

const mapStateToProps = state => {
  return {
    userId: state.manageLogin.user.pk
  }
}

export default connect(mapStateToProps, { getNotifications, checkSSOToken })(AuthenticationComponent);



// WEBPACK FOOTER //
// ./src/AuthenticationComponent.js